<template>
  <v-app :style="theme">
    <NavBar />

    <RouterView />
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar';

export default {
  name: 'HomePage',
  components: {
    NavBar
  },

  computed: {
    theme() {
      return this.$theme.cssProps;
    }
  },

  mounted() {
    document.title = `${this.$tenant?.tenantName} Fleet Tracker`;
  }
};
</script>
